import { Field, font, oPopupPadding, Popup } from '@approvalmax/ui';
import { NotSyncedIcon } from 'modules/sprites';
import styled from 'styled-components';

export const Root = styled(Popup.DefaultContent)`
    width: 930px;
    min-height: 400px;
`;

export const Content = styled.div`
    ${oPopupPadding()}

    display: flex;
    flex-flow: column;
    overflow-y: auto;
`;

export const WrapFieldRow = styled.div`
    display: flex;
    flex-flow: row wrap;
    margin: 0 -10px;

    &:not(:first-child) {
        margin-top: 15px;
    }

    & > * {
        flex: 1;
        min-width: 180px;
        max-width: 180px;
        margin: 0 10px 15px 10px;
    }
`;

export const Header = styled.div`
    ${font(18, '#333333')}
    text-transform: uppercase;
    margin-top: 10px;
`;

export const DateRow = styled.div`
    display: flex;
    flex-flow: column;
    margin-bottom: 15px;
`;

export const DateFieldRow = styled.div`
    display: flex;
    align-items: center;

    & > :nth-child(odd) {
        ${font(13, '#1d2e39')};
        margin-right: 10px;
    }

    & > :nth-child(3) {
        margin-left: 10px;
    }

    & > :nth-child(even) {
        width: 140px;
    }
`;

export const CompanyField = styled(Field)`
    min-width: 380px;
    max-width: 380px;
`;

export const IntegrationWarnBlock = styled.div`
    margin: 10px 0;
`;

export const ImportantNotice = styled.div`
    display: flex;
    align-items: center;
    padding: 14px 0 14px 20px;
    background: #f7f7f7;
`;

export const ImportantNoticeWarnIcon = styled(NotSyncedIcon)`
    margin-right: 15px;
`;

export const ImportantNoticeText = styled.div`
    white-space: pre-line;
    flex: 1;

    ${font(12, '#565656')}
`;
